export default __webpack_public_path__ + "static/media/warehousepic1.c7e4b0b8.jpg";